module.exports = __webpack_public_path__ + "static/img/team5.adf6ca8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instructors/team5.jpg
// module id = f3mX
// module chunks = 1